@if (login) {
<a routerLink="/login"
  class="glass-pill link inline-flex items-center px-3 py-1.5">{{ 'components.login-link.login' | translate }}</a>
} @else {
<a (click)="logout()"
  class="glass-pill link inline-flex items-center px-3 py-1.5 cursor-pointer">{{ 'components.login-link.logout' | translate }}</a>
}
